import type { NetizenVoice } from "@/mocks/events";

const attitudeClass: Record<NetizenVoice["attitude"], string> = {
  挺方: "bg-primary-100 text-primary-800",
  反方: "bg-secondary-200 text-secondary-900",
  中立: "bg-background-200 text-foreground-600",
};

export default function NetizensBlock({ netizens }: { netizens: NetizenVoice[] }) {
  return (
    <section id="sec-netizens" className="scroll-mt-20">
      <h2 className="flex items-center gap-2.5 font-heading text-xl font-black text-foreground-950 md:text-2xl">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
          <i className="ri-message-3-line" aria-hidden="true"></i>
        </span>
        网友评论观察
      </h2>
      <p className="mt-2 text-sm text-foreground-600">
        摘录公开可检索的高赞表达并匿名化昵称，仅供观察舆论分布，不代表本站观点。
      </p>

      <ul className="mt-8 space-y-3">
        {netizens.map((n) => (
          <li
            key={n.text}
            className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-sm font-bold text-accent-800">
              {n.nick.replace("@", "").slice(0, 1)}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-sm font-semibold text-foreground-800">{n.nick}</span>
                <span className={`rounded-full px-2 py-0.5 text-[11px] ${attitudeClass[n.attitude]}`}>
                  {n.attitude}
                </span>
              </div>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{n.text}</p>
            </div>
            <span className="flex shrink-0 items-center gap-1 text-xs text-foreground-400">
              <i className="ri-thumb-up-line" aria-hidden="true"></i>
              {n.likes}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}